//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      defaultDocsHeadline: "Create your document in 3 steps",
      defaultDocSteps: [
        { table: { icon: "checkmark", step_name: "Complete the form" } },
        { table: { icon: "preview", step_name: "Preview your document" } },
        { table: { icon: "print", step_name: "Download and print" } },
      ],
    };
  },
  computed: {
    steps() {
      if (this.data.table.steps.length > 0) return this.data.table.steps;
      else return this.defaultDocSteps;
    },
  },
  props: {
    data: {
      required: true,
    },
    cta: {
      required: true,
    },
  },
};
